import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { StatusCode } from '@yandex-video-platform/goloom-sdk';

import { DeviceErrorCode } from './types';

export type DeviceKind = 'audioinput' | 'audiooutput' | 'videoinput';

export type DeviceManagerState = {
    modalVisibility: {
        [key in DeviceKind]?: boolean;
    };
} & {
    [key in DeviceKind]?: DeviceErrorCode;
};

export interface SetDeviceErrorPayload {
    kind: DeviceKind;
    error: DeviceErrorCode;
}

export interface ResetDeviceErrorPayload {
    kind: DeviceKind;
    error?: StatusCode;
}
export interface SetDeviceErrorModalVisibilityPayload {
    kind: DeviceKind;
    isVisible: boolean;
}

const initialState: DeviceManagerState = {
    modalVisibility: {
        audioinput: false,
        videoinput: false,
    },
};

const deviceManagerSlice = createSlice({
    name: 'deviceManager',
    initialState,
    reducers: {
        setDeviceError(state: DeviceManagerState, action: PayloadAction<SetDeviceErrorPayload>) {
            const { kind, error } = action.payload;
            state[kind] = error;
        },
        resetDeviceError(state: DeviceManagerState, action: PayloadAction<ResetDeviceErrorPayload>) {
            const { kind, error } = action.payload;

            if (!error || state[kind] === error) {
                delete state[kind];
            }
        },
        setDeviceErrorModalVisibility(
            state: DeviceManagerState,
            action: PayloadAction<SetDeviceErrorModalVisibilityPayload>
        ) {
            const { kind, isVisible } = action.payload;
            state.modalVisibility[kind] = isVisible;
        },
    },
});

export const { setDeviceError, resetDeviceError, setDeviceErrorModalVisibility } = deviceManagerSlice.actions;

export const deviceManagerReducer = deviceManagerSlice.reducer;
